export default class AssessmentLibrary {
    constructor () {
        this.library = document.querySelector('[data-assessment-library]')

        if (!this.library)
            return

        this.readMoreBtn = this.library.querySelector('[data-read-more]')
        this.searchInput = this.library.querySelector('[data-search-input]')
        this.searchForm = this.library.querySelector('[data-search-form]')
        this.list = this.library.querySelector('[data-list]')
        this.items = Array.from(this.list.querySelectorAll('[data-list-item]'))

        this.readMoreBtn.addEventListener('click', this.handleReadMore.bind(this))
        this.searchInput.addEventListener('input', this.handleSearch.bind(this))
        this.searchForm.addEventListener('submit', (e) => e.preventDefault())
    }

    handleReadMore (e) {
        e.preventDefault()
        this.library.classList.add('open')
    }

    handleSearch (e) {
        const { value } = e.target

        if (value.length > 0) {
            // Filter list items
            this.library.classList.add('searching')
            this.library.classList.add('open')

            let resultCount = 0

            this.items.forEach((item) => {
                const title = item.textContent.trim()

                if (title.toLowerCase().includes(value.toLowerCase())) {
                    item.classList.remove('hidden')
                    resultCount += 1
                }
                else
                    item.classList.add('hidden')
            })

            if (resultCount === 0)
                this.library.classList.add('no-results')
            else
                this.library.classList.remove('no-results')
        }
        else {
            // Empty search
            this.library.classList.remove('searching')
            this.library.classList.remove('open')
            this.items.forEach((item) => item.classList.remove('hidden'))
        }
    }
}
